import { useQuery } from '@apollo/client';
import { PortfolioInstitution } from '@bakerweb/models';
import { GET_INSTITUTIONS } from '../graphql/queries/getInstitutions';

export const useGetInstitutions = (institutionIds: (string | null | undefined)[]) => {
  // Filter out null/undefined and get unique IDs
  const validIds = Array.from(
    new Set(institutionIds.filter((id): id is string => id !== null && id !== undefined))
  );

  const { data, loading, error } = useQuery<{ institutions: PortfolioInstitution[] }>(GET_INSTITUTIONS, {
    variables: { institutionIds: validIds },
    skip: validIds.length === 0,
    fetchPolicy: 'cache-first'
  });

  // Create a map keyed by institutionId for easy lookup
  const institutionsMap = new Map<string, PortfolioInstitution>();
  data?.institutions?.forEach((institution) => {
    institutionsMap.set(institution.institutionId, institution);
  });

  return {
    loading,
    error,
    institutionsMap
  };
};

